// src/config/downloads.js
//
// The apps offered on the Downloads page. Each app's details are NOT written
// here: they are fetched from a small JSON file its publisher keeps beside the
// releases (Kuestion for Android downloads data v1, 4 Oct 2026), so a new
// version needs no frontend change and no redeploy.
//
// What IS written here is only what never changes between releases — the feed
// address, the stable download address, and the copy shown if the feed cannot
// be read. A failed fetch must never leave the page without a working download.
//
// Adding an app is one more entry in this list; the page counts and groups
// what it finds.

import { TERMINALX_PATH } from './terminalx';

export const DOWNLOADS_PATH = '/downloads';

// `icon` names the mark the page draws beside the title (see DownloadsPage);
// `about`, where the app has a page on the site, is the link under the button.

export const DOWNLOAD_APPS = [
  {
    id: 'kuestion-android',
    platform: 'Android',
    icon: 'kuestion',
    feed: 'https://raw.githubusercontent.com/RiftWorksApps/kuestion-releases/main/kuestion-android.json',
    fallback: {
      title: 'Kuestion for Android',
      description: 'The Rift Works exam app. Students sit the exams their teacher assigned and practise as often as they like; solo users build their own question banks and mock papers; examiners read their cohort’s results on the go.',
      // Never changes and always serves the newest APK (data note §5).
      download_url: 'https://github.com/RiftWorksApps/kuestion-releases/releases/latest/download/Kuestion.apk',
      install: {
        heading: 'How to install',
        steps: [
          'Tap Download, then open the file when it finishes.',
          'If your phone asks, allow your browser to "install unknown apps". This is asked once.',
          'Tap Install. If you already have Kuestion, this updates it and keeps your data.',
        ],
      },
    },
  },
  {
    id: 'terminalx-windows',
    platform: 'Windows',
    icon: 'terminalx',
    about: { to: TERMINALX_PATH, label: 'Read about TerminalX' },
    feed: 'https://raw.githubusercontent.com/RiftWorksApps/terminalx-releases/main/terminalx-windows.json',
    fallback: {
      title: 'TerminalX for Windows',
      description: 'The Rift Works console for network engineers: serial, telnet and SSH in one window, with an AI Helper reading the console beside you, an IP scanner and a TFTP server as tabs.',
      // Never changes and always serves the newest setup (same scheme as Kuestion).
      download_url: 'https://github.com/RiftWorksApps/terminalx-releases/releases/latest/download/TerminalXSetup.exe',
      install: {
        heading: 'How to install',
        steps: [
          'Click Download, then open TerminalXSetup.exe when it finishes.',
          'If Windows SmartScreen warns about an unrecognised app, choose More info, then Run anyway. The setup is not code-signed yet.',
          'Accept the license agreement, choose the folder and shortcuts, and click Install. If TerminalX is already on this PC this updates it and keeps your settings, hosts and logs.',
        ],
      },
    },
  },
];
